/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataCto } from '../../models/demo-account-data-cto';

export interface GetDemoAccountDataVersionAsync$Json$Params {
  demoDataType: ClassificationType;
  documentId: string;
}

export function getDemoAccountDataVersionAsync$Json(http: HttpClient, rootUrl: string, params: GetDemoAccountDataVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
  const rb = new RequestBuilder(rootUrl, getDemoAccountDataVersionAsync$Json.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoAccountDataCto>;
    })
  );
}

getDemoAccountDataVersionAsync$Json.PATH = '/demo-account-data/{demoDataType}/history/{documentId}';
